import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import Button from '../../../../designSystem/Button/Button';
import { api } from '../../../../../utils/api/api';
import { useMutation, useQueryClient } from 'react-query';
import { REGISTER_DOCUMENT_QUERY_KEY, queryUploadDocPUB } from './RegisterPUBDocumentsStep.query';
import { RegisterResponse } from '../../../../../types/api/endpoints/auth/register.types';
import { useCookies } from 'react-cookie';
import moment from 'moment';
import RegisterStepButton from '../../../../commons/RegisterStepButton/RegisterStepButton';
import { useCurrentUser } from '../../../../../hooks/useCurrentUser/useCurrentUser';
import { setProfile } from '../../../../../store/authentication/authenticationActions/authenticationActions';
import { getStepIdFromPUBStep } from '../../../../../utils/helpers/user/getStep';
import { useDispatch } from 'react-redux';
import { RegisterStepsList } from '../RegisterSteps.types';
import { UserPUB } from '../../../../../types/models/user/user.types';
import { useIsDev } from '../../../../../hooks/useIsDev/useIsDev';

export default () => {

  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  const IS_DEV = useIsDev();

  const currentUser = useCurrentUser() as UserPUB;

  const [, setCookie, removeCookie] = useCookies(['token']);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: {
      // 'image/*': ['.png', '.jpg', '.jpeg'],
      'application/pdf': ['.pdf'],
    },
  });

  const { mutate } = useMutation<Awaited<RegisterResponse>, Error, FormData>(
    (data) => queryUploadDocPUB(data),
    {
      mutationKey: REGISTER_DOCUMENT_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: async ({ accessToken }) => {
        api.setHeader('authorization', `Bearer ${accessToken}`);
        removeCookie('token', { path: '/' });
        setCookie('token', accessToken, {
          expires: moment().add(60, 'minutes').toDate(),
          path: '/',
        });
        setProfile({ ...currentUser, id_step: getStepIdFromPUBStep(RegisterStepsList.Documents) })(
          dispatch
        );
        // window.location.pathname = 'dashboard'
      },
      onError: async (error) => {
        alert(error.message);
      },
    }
  );

  const onSubmit = useCallback(() => {
    const formData = new FormData();
    for (const file of acceptedFiles) {
      formData.append('files', file);
    }
    mutate(formData);
  }, [acceptedFiles]);

  return (
    <form className="form">
      <a
        className="btn bg-primary-gradient text-white font-light btn-lg"
        style={{
          marginBottom: 'var(--spacing-s)',
        }}
        target="_blank"
        rel="noreferrer"
        href={`${IS_DEV ? 'http://localhost:3000' : 'https://publiconsult.fr'}/portal/inscription_acheteur_public.pdf`}
      >
        Télécharger le document
      </a>
      <div {...getRootProps({ className: 'dropzone register__dropzone' })}>
        <input {...getInputProps()} />
        <p>
          Glissez le document <strong>tamponné et signé</strong> ici
        </p>
        {acceptedFiles.length > 0 && <span>{acceptedFiles[0].name}</span>}
      </div>
      <RegisterStepButton />
      <Button
        onClick={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        disabled={acceptedFiles.length === 0}>
        Soumettre
      </Button>
    </form>
  );
};
